import React from "react";
import { ArrowRight } from "lucide-react";

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL;

/**
 * Conversion CTA shown at the bottom of result pages.
 * If REACT_APP_CALENDLY_URL is set, opens Calendly; otherwise falls back to mailto.
 */
export const BriefingCTA = ({ testId = "briefing-cta", subject = "Schedule a briefing" }) => {
  const href =
    CALENDLY_URL ||
    `mailto:info@aurorainsights.co?subject=${encodeURIComponent(subject)}`;

  return (
    <section
      className="border-t border-[#A88059]/40 pt-10 mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5"
      data-testid={testId}
    >
      <div>
        <div className="label-eyebrow mb-2">Next Step</div>
        <p className="font-body text-[#190F08] text-lg leading-relaxed max-w-xl">
          Want to walk through this assessment with an Aurora senior adviser?
        </p>
      </div>
      <a
        href={href}
        target={CALENDLY_URL ? "_blank" : undefined}
        rel={CALENDLY_URL ? "noopener noreferrer" : undefined}
        className="btn-primary inline-flex items-center whitespace-nowrap"
        data-testid={`${testId}-link`}
      >
        Schedule a 30-minute briefing
        <ArrowRight size={14} className="ml-2" />
      </a>
    </section>
  );
};
